import React from 'react';
import PropTypes from 'prop-types';
import { Box, Card, CardActionArea, CardContent, Typography } from '@mui/material';
import { getMenuIcon } from '../../../config/navigation/menuIcons';
import useDashboardHubSx from '../hooks/useDashboardHubSx';

export default function QuickLinkCard({ link, onOpen }) {
  const styles = useDashboardHubSx();
  const IconComponent = getMenuIcon(link.iconKey);

  return (
    <Card elevation={0} sx={styles.quickLinkCard}>
      <CardActionArea
        sx={styles.quickLinkAction}
        onClick={() => onOpen?.(link.route)}
        aria-label={`Open ${link.title}`}
      >
        <CardContent sx={styles.quickLinkContent}>
          <Box sx={styles.quickLinkIconWrap} aria-hidden>
            {IconComponent ? <IconComponent sx={{ fontSize: 22, color: 'inherit' }} /> : null}
          </Box>
          <Typography component="h3" sx={styles.quickLinkTitle}>
            {link.title}
          </Typography>
          <Typography sx={styles.quickLinkDescription}>{link.description}</Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}

QuickLinkCard.propTypes = {
  link: PropTypes.shape({
    key: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    description: PropTypes.string,
    route: PropTypes.string.isRequired,
    iconKey: PropTypes.string,
  }).isRequired,
  onOpen: PropTypes.func,
};
